<template>
    <div v-if="dados && dados.atendimento && dados.atendimento.pagamento_atendimento">
        <div class="alert alert-primary text-center mt-3">
            <div class="lead mr-2">Recibo</div>
            <div class="display-4" v-if="dados">
                Nº {{ dados.atendimento.pagamento_atendimento.id_pagamento_atendimento }}
            </div>
            <div v-else>Carregando...</div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>

        <div>
            <!-- Notas Fiscais -->
            <template v-if="dados && dados.unidade_operacao && dados.unidade_operacao.fl_nota_fiscal">
                <button class="btn btn-outline-primary mb-2" @click.prevent="gerarNF()" :disabled="$store.state.loading">
                    {{ (listaNf && listaNf.length == 0 ) ? 'Emitir Nota Fiscal' : 'Regerar Nota Fiscal' }}
                </button>

                <template v-if="possuiNF">
                    <az-sub-title title="Notas fiscais" />

                    <div class="list-group mb-3">
                        <div class="list-group-item d-flex" v-for="(nfl, idx) in listaNf" :key="idx">
                            <span class="mr-3">{{ $util.getFormatDate(nfl.nota_fiscal_servico.dt_emissao)}}</span>
                            <span class="mr-3 text-warning" v-if="nfl.nota_fiscal_servico.dt_competencia && !is_mes_atual(nfl.nota_fiscal_servico)">{{ $util.getFormatDate(nfl.nota_fiscal_servico.dt_competencia, "MM/YYYY", false)}}</span>
                            <span class="mr-3">{{ nfl.nota_fiscal_servico.numero_completo }}</span>
                            <span class="mr-3" v-if="nfl.nota_fiscal_servico.st_numero != nfl.nota_fiscal_servico.st_numero_nf && nfl.nota_fiscal_servico.st_numero_nf">RPS: {{ nfl.nota_fiscal_servico.st_numero }}</span>
                            <span class="mr-3">{{ nfl.nota_fiscal_servico.st_tomador_nome }}</span>
                            <span class="mr-3" v-if="nfl.nota_fiscal_servico.unidade_operacao">
                                <span class="y" title="Unidade Emissora da Nota Fiscal">
                                {{ nfl.nota_fiscal_servico.unidade_operacao.st_sigla
                                    ? nfl.nota_fiscal_servico.unidade_operacao.st_sigla
                                    : nfl.nota_fiscal_servico.unidade_operacao.st_nome }}
                                </span>
                            </span>

                            <span class="mr-3" v-if="nfl.nota_fiscal_servico.dc_valor_servicos">
                                {{ $util.formatMoeda(nfl.nota_fiscal_servico.dc_valor_servicos) }}
                            </span>

                            <span
                                class="mr-3"
                                :class="
                                    getStatusClass(
                                        nfl.nota_fiscal_servico.ch_status
                                    )
                                "
                                >{{
                                    nfl.nota_fiscal_servico.descricao_status
                                }}</span
                            >
                            <span
                                class="mr-3"
                                v-if="
                                    dados &&
                                        dados.unidade_operacao &&
                                        dados.unidade_operacao
                                            .fl_nota_fiscal_eletronica
                                "
                            >
                                <span
                                    v-if="nfl.adiantamento"
                                    class="badge badge-warning ml-2"
                                >
                                    Adiantamento
                                </span>

                                <nota-fiscal-status 
                                    v-else
                                    :exibirEditar="false"
                                    :notaFiscal="nfl.nota_fiscal_servico"
                                    @refresh="load()"
                                    @integrar="integrar()"
                                />
                            </span>
                            <span class="mr-5 mt-1 small text-danger"
                                v-if="nfl.nota_fiscal_servico.st_erro && nfl.nota_fiscal_servico.ch_erro_emissao != '0' && nfl.nota_fiscal_servico.ch_status == '1'">
                                Erro: {{ nfl.nota_fiscal_servico.st_erro }}
                            </span>
                        </div>
                    </div>
                </template>
            </template>

            <div style="display: flex; flex-direction: row; gap: 10px;">
                <template v-if="dados && contself">
                    <contself-status class="mb-3" ref="contselfStatus" @refresh="load()" :atendimento="marcacao.atendimento"/>
                </template>
                <!-- <template v-if="false && dados && zoop && dados.atendimento && dados.atendimento.pagamento_atendimento && dados.atendimento.pagamento_atendimento.id_pagamento_atendimento">
                    <zoop-status class="mb-3" ref="zoopStatus" 
                        @refresh="load()" 
                        :id_pagamento_atendimento="dados.atendimento.pagamento_atendimento.id_pagamento_atendimento"
                    />
                </template> -->
                <template v-if="dados && suportpos">
                    <suport-pos-status class="mb-3" ref="suportposStatus" @refresh="load()" :id_pagamento_atendimento="dados.atendimento.pagamento_atendimento.id_pagamento_atendimento" :marcacao="marcacao"/>
                </template>
            </div>
        </div>

        <div v-if="dados" v-show="false">
            <html-report id="recibo" :header="false" :forceheader="false" ref="reportRecibo">
                <!-- Copia 1 -->
                <div style="font-size:16px;">
                    <div v-if="unidade && ( !unidade.fl_timbrado || true )" style="line-height: 95%;">
                        <div v-if="logo_url">
                            <img v-if="logo_url" :src="logo_url" height="120mm" />
                            <img v-else-if="$store.state.logo" :src="$store.state.logo" height="120mm" />
                        </div>

                        <div class="d-flex justify-content-between">
                            <div class="d-flex flex-column">
                                <!-- Nome da Empresa -->
                                <template v-if="!logo_url">
                                    <h4 v-if="nome_empresa" class="mb-0">
                                        {{ nome_empresa }}
                                    </h4>
                                    <h4 v-else-if="parms && parms.nome_contratado" class="mb-0">
                                        {{ parms.nome_contratado }}
                                    </h4>
                                    <h4 v-else class="mb-0">
                                        {{ unidade.st_nome_fantasia }}
                                    </h4>
                                </template>
                                <!-- Fim Nome da Empresa -->
                                <h6 v-if="unidade.st_unidade_operacao && unidade.unidade_operacaos && unidade.unidade_operacaos.length > 1" class="mb-0">
                                    {{ unidade.st_unidade_operacao }}
                                </h6>
                                <div v-if="unidade.endereco" class="font-weight-light">
                                    {{ unidade.endereco.st_logradouro }}, {{ unidade.endereco.st_numero }}
                                    <span v-if="unidade.endereco.st_complemento">- {{ unidade.endereco.st_complemento }}</span>
                                    - Bairro: {{ unidade.endereco.st_bairro }}
                                    - Cep:
                                    {{
                                        this.$util.formatMask(
                                            unidade.endereco.in_cep,
                                            "cep"
                                        )
                                    }}-
                                    {{
                                        unidade.endereco.cidade
                                            ? unidade.endereco.cidade.st_cidade
                                            : ""
                                    }}
                                </div>
                                <div>
                                    <div v-if="parms && parms.codigo_contratado">
                                        {{ parms.codigo_contratado }}
                                    </div>
                                    <div v-else-if="unidade.st_cnpj && exibir_cnpj">
                                        CNPJ:
                                        {{
                                            this.$util.formatMask(
                                                unidade.st_cnpj,
                                                "cnpj"
                                            )
                                        }}
                                    </div>
                                    <div v-if="dados && dados.unidade_operacao && dados.unidade_operacao.telefone_unidade_operacaos && dados.unidade_operacao.telefone_unidade_operacaos.length">
                                        Tel: <span v-for="(tel, idx) in dados.unidade_operacao.telefone_unidade_operacaos" :key="idx">
                                            {{
                                                $util.formatMask(
                                                    tel.telefone.st_numero,
                                                    tel.telefone.st_numero.length == 10
                                                        ? "tel"
                                                        : "cel"
                                                )
                                            }}
                                            <span v-if="idx < dados.unidade_operacao.telefone_unidade_operacaos.length - 1">/</span>
                                        </span>
                                    </div>
                                    <div v-else-if="unidade.st_telefone_representante">
                                        Tel:
                                        {{
                                            $util.formatMask(
                                                unidade.st_telefone_representante,
                                                unidade
                                                    .st_telefone_representante
                                                    .length == 10
                                                    ? "tel"
                                                    : "cel"
                                            )
                                        }}
                                    </div>
                                    <br />
                                </div>
                            </div>
                            <div v-if="!logo_url">
                                <img v-if="logo_url" :src="logo_url" height="80mm" />
                                <img v-else-if="$store.state.logo" :src="$store.state.logo" height="80mm" />
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-column" stylex="margin-top:1cm;">
                        <h3 class="mx-auto mb-3">
                            Recibo Nª
                            {{
                                dados.atendimento.pagamento_atendimento
                                    .id_pagamento_atendimento
                            }}
                        </h3>
                        <div class="mx-auto" style="text-align: justify; text-justify: inter-word;">
                            Recebemos de {{ responsavel }} a importância de R$
                            {{ this.$util.formatMoeda(valor_total) }} referente
                            a quitação de
                            {{ dados.fl_particular ? 'serviços realizados' : 'despesas médicas' }}
                            conforme dados do atendimento Nº
                            {{ dados.atendimento.id_atendimento }}.
                        </div>
                        <br />

                        <div v-if="metodoPagamentos" class="mb-3">
                            <ul v-for="(pagamento, index) in metodoPagamentos" :key="index" style="line-height: 70%;">
                                <li>
                                    <small v-if="pagamento.forma_pagamento">
                                        {{ pagamento.forma_pagamento }}
                                    </small>
                                    {{ pagamento.st_pagamento }}: R$
                                    {{ $util.formatMoeda(pagamento.dc_valor) }}

                                    <span class="small text-muted ml-5" v-if="pagamento.transaction_id">{{ pagamento.transaction_id }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-if="dados && dados.atendimento && dados.atendimento.pagamento_atendimento && dados.atendimento.pagamento_atendimento.st_numero_nf">
                        NF: {{ dados.atendimento.pagamento_atendimento.st_numero_nf }}
                        / Chave: {{ dados.atendimento.pagamento_atendimento.st_chave_acesso }}
                    </div>

                    <div class="d-flex flex-column">
                        <template v-if="false">
                            <div
                                class="font-weight-bold border-bottom w-100 d-flex justify-content-center"
                            >
                                <h4>Dados do Atendimento</h4>
                            </div>
                            <div class="d-flex flex-column p-3">
                                <div class="row d-flex">
                                    <p class="mr-2">
                                        Registro:{{
                                            dados.atendimento
                                                .pagamento_atendimento
                                                .id_pagamento_atendimento
                                        }}
                                    </p>
                                    <p
                                        v-if="dados.paciente.st_nome_social"
                                        class="mr-2"
                                    >
                                        Paciente:{{
                                            dados.paciente.st_nome_social
                                        }}

                                        <span class="small ml-2">(Nome Civil: {{ dados.paciente.st_nome }})</span>
                                    </p>
                                    <p v-else class="mr-2">
                                        Paciente:{{ dados.paciente.st_nome }}
                                    </p>
                                </div>
                                <p class="row" v-if="endereco">
                                    {{ endereco }}
                                </p>

                                <!-- Endereço:{{ dados.paciente.cadastro.endereco.st_logradouro }},{{ dados.paciente.cadastro.endereco.st_numero}} Bairro: {{ dados.paciente.cadastro.endereco.st_bairro }}. {{dados.paciente.cadastro.endereco.cidade ? dados.paciente.cadastro.endereco.cidade.st_cidade : ''}}</p> -->
                                <div class="d-flex row">
                                    <p class="mr-2">
                                        Nª do Atendimento:
                                        {{ dados.atendimento.id_atendimento }}
                                    </p>
                                    <p class="mr-2">
                                        Data Atendimento:
                                        {{
                                            formatData(
                                                this.dados.atendimento.dt_inicio
                                            )
                                        }}
                                    </p>
                                </div>
                            </div>
                        </template>

                        <template v-if="dados.fl_particular">
                            <div class="d-flex flex-column">
                                <div
                                    class="font-weight-bold border-bottom w-100 mx-auto"
                                >
                                    Serviços Realizados
                                </div>
                                <table class="border-bottom">
                                    <thead class="font-weight-bold">
                                        <tr>
                                            <td class="w-50">
                                                Procedimento(s)
                                            </td>
                                            <td></td>
                                            <td class="text-right">
                                                Quantidade
                                            </td>
                                            <td class="text-right">
                                                Valor(R$)
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody class="border border-left-0 border-right-0">
                                        <template v-for="(item, id) in procedimentos"> <!-- class="border-bottom" -->
                                            <tr :key="id" class="border-top" v-if="item.valor > 0">
                                                <td>{{ item.nome }}</td>
                                                <td></td>
                                                <td class="text-right">
                                                    {{ item.quantidade }}
                                                </td>
                                                <td class="text-right">
                                                    {{
                                                        formatCurrency(
                                                            item.valor
                                                        )
                                                    }}
                                                </td>
                                            </tr>

                                            <tr class="my-1 font-weight-bold mr-2"
                                                style="font-size:12px; margin-left:2cm; width:91%;" 
                                                v-for="(equipe, iex) in item.equipes" :key="'E' + id + '.' + iex">
                                                <td>{{ equipe.nome_item }}</td>
                                                <td></td>
                                                <td class="text-right">
                                                    {{ equipe.quantidade }}
                                                </td>
                                                <td class="text-right">
                                                    {{ formatCurrency(equipe.valor) }}
                                                </td>
                                            </tr>

                                            <tr v-if="item.consumos.length && !consolidar_matmed"
                                                class="my-1 font-weight-bold mr-2"
                                                style="font-size:12px; margin-left:2cm; width:91%;"
                                                :key="'mat' + id">
                                                <td class="pl-4">
                                                    Material/Medicamento
                                                </td>
                                                <td class="text-right">
                                                    Valor Unitário
                                                </td>
                                                <td class="text-right">
                                                    Quantidade
                                                </td>
                                                <td class="text-right">
                                                    Valor Total(R$)
                                                </td>
                                            </tr>

                                            <tr v-for="(itemConsumo, indice) in item.consumos" :key="'consumo1.' + id + '.' + indice" class="mr-2">
                                                <td class="pl-4">
                                                    {{ itemConsumo.nome_item }}
                                                </td>
                                                <td class="text-right">
                                                    {{
                                                        consolidar_matmed 
                                                        ? ''
                                                        : formatCurrency(
                                                            itemConsumo.valor_unitario
                                                        )
                                                    }}
                                                </td>
                                                <td class="text-right">
                                                    {{ itemConsumo.quantidade }}
                                                </td>
                                                <td class="text-right">
                                                    {{
                                                        formatCurrency(
                                                            itemConsumo.valor
                                                        )
                                                    }}
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>

                            <div class="d-flex justify-content-between mt-4">
                                <div>
                                    <div v-if="dados.medico_no_recibo && dados.atendimento && dados.atendimento.medico" class="small">
                                        {{ dados.atendimento.medico.st_nome_exibicao }}
                                        <div v-if="dados.atendimento.medico.conselho">
                                            {{ dados.atendimento.medico.conselho.st_sigla }}
                                            {{ dados.atendimento.medico.in_numero_conselho }}
                                            <span v-if="dados.atendimento.medico.estado_conselho">
                                                {{ dados.atendimento.medico.estado_conselho.st_sigla }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <table class="text-right">
                                    <tr class="ml-2">
                                        <td class="font-weight-bold">Valor Total(R$):</td>
                                        <td>{{ formatCurrency(total) }}</td>
                                    </tr>
                                    <tr class="ml-2" v-if="desconto > 0">
                                        <td class="font-weight-bold">Valor Desconto(R$):</td>
                                        <td>{{ formatCurrency(desconto) }}</td>
                                    </tr>
                                    <tr v-if="desconto > 0 && total > 0">
                                        <td></td>
                                        <td>
                                            <div class="small">
                                                {{ formatCurrency( ( desconto / total ) * 100 ) }}%
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="ml-2">
                                        <td class="font-weight-bold">Valor Pago(R$):</td>
                                        <td>{{ formatCurrency(total - desconto - valor_pendente) }}</td>
                                    </tr>
                                    <tr class="ml-2" v-if="valor_pendente > 0">
                                        <td class="font-weight-bold">Valor Pendente(R$):</td>
                                        <td>{{ formatCurrency(valor_pendente) }}</td>
                                    </tr>
                                </table>
                            </div>
                        </template>
                    </div>

                    <div v-if="dados" class="mx-auto" style="font-size:14px;">
                        {{
                            dados.unidade.endereco &&
                            dados.unidade.endereco.cidade
                                ? dados.unidade.endereco.cidade.st_cidade
                                : ""
                        }},
                        {{ formatData(dados.atendimento.dt_inicio) }}
                    </div>

                    <div class="d-flex justify-content-between mt-2 ml-4 mr-4">
                        <div
                            class="d-flex flex-column justify-content-center ml-5 text-center"
                        >
                            <div>
                                __________________________________________
                            </div>
                            <div><small>Paciente</small></div>
                        </div>
                        <div
                            class="d-flex flex-column justify-content-center ml-5 text-center"
                        >
                            <div>
                                __________________________________________
                            </div>
                            <div><small>{{ titulo_ass }}</small></div>
                        </div>
                    </div>
                </div>

                <div v-if="texto_rodape" class="text-center small mt-5" style="white-space: pre-wrap;">{{ texto_rodape }}</div>

                <div class="row mt-4">
                    <div class="col">
                        <tiss-rodape
                            v-if="dados.atendimento && dados.atendimento.usuario"
                            :infoId="dados.atendimento.id_atendimento"
                            :responsavel="dados.atendimento.usuario.st_login" />
                    </div>
                </div>

                <div class="d-flex justify-content-center mt-0 mb-4">
                    <span>----------------------------------------------------------------</span>
                </div>

                <!-- Copia 2 -->
                <div style="font-size:16px;" v-if="!uma_via">
                    <div
                        v-if="unidade && ( !unidade.fl_timbrado || true )"
                        style="line-height: 95%;"
                    >
                        <div v-if="logo_url">
                            <img v-if="logo_url" :src="logo_url" height="120mm" />
                            <img v-else-if="$store.state.logo" :src="$store.state.logo" height="120mm" />
                        </div>
                        <div class="d-flex justify-content-between">
                            <div class="d-flex flex-column">
                                <!-- Nome da Empresa -->
                                <template v-if="!logo_url">
                                    <h4 v-if="nome_empresa" class="mb-0">
                                        {{ nome_empresa }}
                                    </h4>
                                    <h4 v-else-if="parms && parms.nome_contratado" class="mb-0">
                                        {{ parms.nome_contratado }}
                                    </h4>
                                    <h4 v-else class="mb-0">
                                        {{ unidade.st_nome_fantasia }}
                                    </h4>
                                </template>
                                <!-- Fim Nome da Empresa -->
                                <h6 v-if="unidade.st_unidade_operacao" class="mb-0">
                                    {{ unidade.st_unidade_operacao }}
                                </h6>
                                <div v-if="unidade.endereco" class="font-weight-light">
                                    {{ unidade.endereco.st_logradouro }},
                                    {{ unidade.endereco.st_numero }}
                                    <span v-if="unidade.endereco.st_complemento">- {{ unidade.endereco.st_complemento }}</span>
                                    - Bairro: {{ unidade.endereco.st_bairro }}
                                    - Cep:
                                    {{
                                        this.$util.formatMask(
                                            unidade.endereco.in_cep,
                                            "cep"
                                        )
                                    }}-
                                    {{
                                        unidade.endereco.cidade
                                            ? unidade.endereco.cidade.st_cidade
                                            : ""
                                    }}
                                </div>
                                <div>
                                    <div
                                        v-if="parms && parms.codigo_contratado"
                                    >
                                        {{ parms.codigo_contratado }}
                                    </div>
                                    <div v-else-if="unidade.st_cnpj && exibir_cnpj">
                                        CNPJ:
                                        {{
                                            this.$util.formatMask(
                                                unidade.st_cnpj,
                                                "cnpj"
                                            )
                                        }}
                                    </div>
                                    <div v-if="dados && dados.unidade_operacao && dados.unidade_operacao.telefone_unidade_operacaos && dados.unidade_operacao.telefone_unidade_operacaos.length">
                                        Tel: <span v-for="(tel, idx) in dados.unidade_operacao.telefone_unidade_operacaos" :key="idx">
                                            {{
                                                $util.formatMask(
                                                    tel.telefone.st_numero,
                                                    tel.telefone.st_numero.length == 10
                                                        ? "tel"
                                                        : "cel"
                                                )
                                            }}
                                            <span v-if="idx < dados.unidade_operacao.telefone_unidade_operacaos.length - 1">/</span>
                                        </span>
                                    </div>
                                    <div v-else-if="unidade.st_telefone_representante">
                                        Tel:
                                        {{
                                            this.$util.formatMask(
                                                unidade.st_telefone_representante,
                                                unidade
                                                    .st_telefone_representante
                                                    .length == 10
                                                    ? "tel"
                                                    : "cel"
                                            )
                                        }}
                                    </div>
                                    <br />
                                </div>
                            </div>
                            <div v-if="!logo_url">
                                <img v-if="logo_url" :src="logo_url" height="80mm" />
                                <img v-else-if="$store.state.logo" :src="$store.state.logo" height="80mm" />
                            </div>
                        </div>
                    </div>

                    <div class="d-flex flex-column" stylex="margin-top:1cm;">
                        <h3 class="mx-auto mb-3">
                            Recibo Nª
                            {{
                                dados.atendimento.pagamento_atendimento
                                    .id_pagamento_atendimento
                            }}
                        </h3>
                        <div
                            class="mx-auto"
                            style="text-align: justify; text-justify: inter-word;"
                        >
                            Recebemos de {{ responsavel }} a importância de R$
                            {{ this.$util.formatMoeda(valor_total) }} referente
                            a quitação de
                            {{ dados.fl_particular ? 'serviços realizados' : 'despesas médicas' }}
                            conforme dados do atendimento Nº
                            {{ dados.atendimento.id_atendimento }}.
                        </div>
                        <br />

                        <div v-if="metodoPagamentos" class="mb-3">
                            <ul
                                v-for="(pagamento, index) in metodoPagamentos"
                                :key="index"
                                style="line-height: 70%;"
                            >
                                <li>
                                    <small v-if="pagamento.forma_pagamento">{{
                                        pagamento.forma_pagamento
                                    }}</small>
                                    {{ pagamento.st_pagamento }}: R$
                                    {{ $util.formatMoeda(pagamento.dc_valor) }}

                                    <span class="small text-muted ml-5" v-if="pagamento.transaction_id">{{ pagamento.transaction_id }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="d-flex flex-column">
                        <template v-if="false">
                            <div
                                class="font-weight-bold border-bottom w-100 d-flex justify-content-center"
                            >
                                <h4>Dados do Atendimento</h4>
                            </div>
                            <div class="d-flex flex-column p-3">
                                <div class="row d-flex">
                                    <p class="mr-2">
                                        Registro:{{
                                            dados.atendimento
                                                .pagamento_atendimento
                                                .id_pagamento_atendimento
                                        }}
                                    </p>
                                    <p
                                        v-if="dados.paciente.st_nome_social"
                                        class="mr-2"
                                    >
                                        Paciente:{{
                                            dados.paciente.st_nome_social
                                        }}

                                        <span class="small ml-2">(Nome Civil: {{ dados.paciente.st_nome }})</span>
                                    </p>
                                    <p v-else class="mr-2">
                                        Paciente:{{ dados.paciente.st_nome }}
                                    </p>
                                </div>
                                <p class="row" v-if="endereco">
                                    {{ endereco }}
                                </p>

                                <!-- Endereço:{{ dados.paciente.cadastro.endereco.st_logradouro }},{{ dados.paciente.cadastro.endereco.st_numero}} Bairro: {{ dados.paciente.cadastro.endereco.st_bairro }}. {{dados.paciente.cadastro.endereco.cidade ? dados.paciente.cadastro.endereco.cidade.st_cidade : ''}}</p> -->
                                <div class="d-flex row">
                                    <p class="mr-2">
                                        Nª do Atendimento:
                                        {{ dados.atendimento.id_atendimento }}
                                    </p>
                                    <p class="mr-2">
                                        Data Atendimento:
                                        {{
                                            formatData(
                                                this.dados.atendimento.dt_inicio
                                            )
                                        }}
                                    </p>
                                </div>
                            </div>
                        </template>

                        <template v-if="dados.fl_particular">
                            <div class="d-flex flex-column">
                                <div
                                    class="font-weight-bold border-bottom w-100 mx-auto"
                                >
                                    Serviços Realizados
                                </div>
                                <table class="border-bottom">
                                    <thead class="font-weight-bold">
                                        <tr>
                                            <td class="w-50">
                                                Procedimento(s)
                                            </td>
                                            <td></td>
                                            <td class="text-right">
                                                Quantidade
                                            </td>
                                            <td class="text-right">
                                                Valor(R$)
                                            </td>
                                        </tr>
                                    </thead>
                                    <tbody
                                        class="border border-left-0 border-right-0"
                                    >
                                        <template v-for="(item, id) in procedimentos"> <!-- class="border-bottom" -->
                                            <tr :key="id" class="border-top" v-if="item.valor > 0">
                                                <td>{{ item.nome }}</td>
                                                <td></td>
                                                <td class="text-right">
                                                    {{ item.quantidade }}
                                                </td>
                                                <td class="text-right">
                                                    {{
                                                        formatCurrency(
                                                            item.valor
                                                        )
                                                    }}
                                                </td>
                                            </tr>

                                            <tr class="my-1 font-weight-bold mr-2"
                                                style="font-size:12px; margin-left:2cm; width:91%;" 
                                                v-for="(equipe, iex) in item.equipes" :key="'E' + id + '.' + iex">
                                                <td>{{ equipe.nome_item }}</td>
                                                <td></td>
                                                <td class="text-right">
                                                    {{ equipe.quantidade }}
                                                </td>
                                                <td class="text-right">
                                                    {{ formatCurrency(equipe.valor) }}
                                                </td>
                                            </tr>

                                            <tr
                                                v-if="item.consumos.length"
                                                class="my-1 font-weight-bold mr-2"
                                                style="font-size:12px; margin-left:2cm; width:91%;"
                                                :key="'mat' + id"
                                            >
                                                <td class="pl-4">
                                                    Material/Medicamento
                                                </td>
                                                <td class="text-right">
                                                    Valor Unitário
                                                </td>
                                                <td class="text-right">
                                                    Quantidade
                                                </td>
                                                <td class="text-right">
                                                    Valor Total(R$)
                                                </td>
                                            </tr>

                                            <tr v-for="(itemConsumo, indice) in item.consumos" :key="'consumo2.' + id + '.' + indice" class="mr-2">
                                                <td class="pl-4">
                                                    {{ itemConsumo.nome_item }}
                                                </td>
                                                <td class="text-right">
                                                    {{
                                                        formatCurrency(
                                                            itemConsumo.valor_unitario
                                                        )
                                                    }}
                                                </td>
                                                <td class="text-right">
                                                    {{ itemConsumo.quantidade }}
                                                </td>
                                                <td class="text-right">
                                                    {{
                                                        formatCurrency(
                                                            itemConsumo.valor
                                                        )
                                                    }}
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </div>

                            <div class="d-flex justify-content-between mt-4">
                                <div>
                                    <div v-if="dados.medico_no_recibo && dados.atendimento && dados.atendimento.medico" class="small">
                                        {{ dados.atendimento.medico.st_nome_exibicao }}
                                        <div v-if="dados.atendimento.medico.conselho">
                                            {{ dados.atendimento.medico.conselho.st_sigla }}
                                            {{ dados.atendimento.medico.in_numero_conselho }}
                                            <span v-if="dados.atendimento.medico.estado_conselho">
                                                {{ dados.atendimento.medico.estado_conselho.st_sigla }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <table class="text-right">
                                    <tr class="ml-2">
                                        <td class="font-weight-bold">Valor Total(R$):</td>
                                        <td>{{ formatCurrency(total) }}</td>
                                    </tr>
                                    <tr class="ml-2" v-if="desconto > 0">
                                        <td class="font-weight-bold">Valor Desconto(R$):</td>
                                        <td>
                                            {{ formatCurrency(desconto) }}
                                        </td>
                                    </tr>
                                    <tr class="ml-2">
                                        <td class="font-weight-bold">Valor Pago(R$):</td>
                                        <td>{{ formatCurrency(total - desconto - valor_pendente) }}</td>
                                    </tr>
                                    <tr class="ml-2" v-if="valor_pendente > 0">
                                        <td class="font-weight-bold">Valor Pendente(R$):</td>
                                        <td>{{ formatCurrency(valor_pendente) }}</td>
                                    </tr>
                                </table>
                            </div>
                        </template>
                    </div>

                    <div v-if="dados" class="mx-auto" style="font-size:14px;">
                        {{
                            dados.unidade.endereco &&
                            dados.unidade.endereco.cidade
                                ? dados.unidade.endereco.cidade.st_cidade
                                : ""
                        }},
                        {{ formatData(dados.atendimento.dt_inicio) }}
                    </div>

                    <div class="d-flex justify-content-between mt-2 ml-4 mr-4">
                        <div
                            class="d-flex flex-column justify-content-center ml-5 text-center"
                        >
                            <div>
                                __________________________________________
                            </div>
                            <div><small>Paciente</small></div>
                        </div>
                        <div
                            class="d-flex flex-column justify-content-center ml-5 text-center"
                        >
                            <div>
                                __________________________________________
                            </div>
                            <div><small>{{ titulo_ass }}</small></div>
                        </div>
                    </div>
                </div>

                <div v-if="texto_rodape" class="text-center small mt-5" style="white-space: pre-wrap;">{{ texto_rodape }}</div>

            </html-report>
            <!-- </div> -->
        </div>

        <!-- Espelho do Atendimento -->
        <template v-if="dados && marcacao">
            <div class="d-flex">
                <div v-if="dados.atendimento.pagamento_atendimento
                    && marcacao
                    && dados.atendimento.pagamento_atendimento.id_pagamento_atendimento
                    && !dados.atendimento.pagamento_atendimento.id_atendimento">

                    <a href="#" @click.prevent="$util.abrirPagamentos(marcacao, dados.atendimento.pagamento_atendimento.id_pagamento_atendimento)" class="btn btn-outline-primary mr-2">
                        Pagamento Consolidado
                    </a>
                </div>

                <div class="mr-2">
                    <button type="button" class="btn btn-outline-primary" @click="abrir_anexar_arquivo()">
                        <i class="fa-solid fa-paperclip"></i>
                        <span class="badge badge-primary ml-1" v-if="marcacao.arquivos && marcacao.arquivos.length > 0">
                            {{ marcacao.arquivos.length }}
                        </span>
                    </button>
                </div>

                <div class="mr-2">
                    <laboratorio-etiqueta ref="labetq" v-model="dados" :canto="true" :fila="true" />
                </div>

                <div class="mr-2">
                    <pacs-status ref="pacsStatus" @refresh="load()" :atendimento="marcacao.atendimento" v-if="exibirPacsStatus(dados)"/>
                </div>
                
                <div>
                    <print-export printid="print-espelho-atendimento" :icon="false">
                        <template v-slot:botao>
                            <span class="mr-2">Espelho do Atendimento</span>
                        </template>

                        <template v-slot:dropdownitem>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" href="#" @click="toggle_exibir_valores()">
                                <i class="fas fa-eye-slash fa-fw mr-2" v-if="espelho_sem_valor"></i>
                                <i class="fas fa-eye fa-fw mr-2" v-else></i>
                                Exibir Valores
                            </a>

                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item" href="#" @click="enviar_espelho()">
                                <i class="far fa-envelope-open fa-fw mr-2"></i>
                                Enviar por E-mail
                            </a>
                            <a class="dropdown-item" href="#" @click="printEtiqueta()">
                                <i class="fa fa-tags fa-fw mr-2" aria-hidden="true"></i>
                                Emitir Etiqueta
                            </a>
                        </template>
                    </print-export>
                </div>

            </div>

            <div id="print-espelho-atendimento" class="d-none d-print-block">
                <espelho-atendimento ref="espelho" :dados="dados" :prazo="dados.exibir_prazo" :sem_valor="espelho_sem_valor" />
            </div>

        </template>

        <template v-if="marcacao">

            <div class="mt-3" v-if="dados && dados.zoop && dados.atendimento && dados.atendimento.pagamento_atendimento">
                <zoop-pagamento :pagamento="dados.atendimento.pagamento_atendimento" />
            </div>

            <!-- Outras Marcações -->
            <outras-marcacoes class="mt-3" :dados="marcacao" @reabrir="reabrir" :pode_encaminhar="true" @encaminhar="$emit('encaminhar', $event)" />

            <!-- Login de Terceiros -->
            <exibir-lab-logins :marcacao="dados ? dados : marcacao" :exibir_prazo="true" />

            <!-- Documentos para Impressão -->
            <doc-print-atendimento class="mt-3" :marcacao="marcacao" id_pagamento_atendimento2="( dados && dados.atendimento && dados.atendimento.pagamento_atendimento ) ? dados.atendimento.pagamento_atendimento.id_pagamento_atendimento : null" />

            <template v-if="acao_anexar">
                <az-file-upload
                    ref="upload"
                    @refresh="carregar_arquivos()"
                    :multiple="true"
                    :arquivos="marcacao.arquivos"
                    :parms="{ 
                        model_type: 'marcacao', 
                        model_id: marcacao.id_marcacao, 
                        id_paciente: marcacao.id_paciente ? marcacao.id_paciente : marcacao.id_pessoa,
                    }" />
            </template>

        </template>

        <!-- Emitir Etiqueta -->
        <emitir-etiqueta ref="etiqueta" sufixo="recibo" />

    </div>
</template>

<script>
import * as moment from "moment";
import _ from "lodash";
import $ from "jquery";
import HtmlReport from "../../relatorios/HTMLReport.vue";
import OutrasMarcacoes from "../../modulos/recepcao/OutrasMarcacoes.vue";
import PrintExport from "../../shared/PrintExport.vue";
import EspelhoAtendimento from "./EspelhoAtendimento.vue";
import NotaFiscalStatus from "../financeiro/NotaFiscalStatus.vue";
import AzSubTitle from '../../util/AzSubTitle.vue';
import AzFileUpload from '../../util/AzFileUpload.vue';
import DocPrintAtendimento from '../../modulos/recepcao/DocPrintAtendimento.vue';
import LaboratorioEtiqueta from './LaboratorioEtiqueta.vue';
import ExibirLabLogins from './ExibirLabLogins.vue';
import TissRodape from "../../tiss/TissRodape";
import PacsStatus from "../../../components/shared/PacsStatus.vue"
import ContselfStatus from "../../../components/shared/ContselfStatus.vue"
//import ZoopStatus from "../../shared/ZoopStatus.vue";
import SuportPosStatus from "../../../components/shared/SuportPosStatus.vue";
import EmitirEtiqueta from '../../shared/EmitirEtiqueta.vue';
import ZoopPagamento from './ZoopPagamento.vue';

export default {
    data() {
        return {
            dados: null,
            parms: null,
            unidade: null,
            copiasRececibo: [0, 1],
            espelho_sem_valor: false,
            uma_via: false,
            exibir_cnpj: false, 
            acao_anexar: false, 
            contself: false,
            zoop: false,
            suportpos: false,
            consolidar_matmed: false, 
            logo_unidade_operacao: null, 
        };
    },
    props: ["marcacao"],
    components: {
        HtmlReport,
        OutrasMarcacoes,
        PrintExport,
        EspelhoAtendimento,
        NotaFiscalStatus,
        AzSubTitle,
        DocPrintAtendimento,
        LaboratorioEtiqueta,
        ExibirLabLogins,
        TissRodape,
        PacsStatus, 
        ContselfStatus, 
        //ZoopStatus,
        SuportPosStatus, 
        AzFileUpload, 
        EmitirEtiqueta, 
        ZoopPagamento,
    },
    methods: {
        printEtiqueta () {
            this.$refs.etiqueta.emitir('marcacao', this.marcacao);
        },
        
        abrir_anexar_arquivo() {
            this.acao_anexar = true;
            this.carregar_arquivos(true);
        },

        carregar_arquivos (abrir = false) {

            this.$store.commit('loading', true);

            if ( this.marcacao.id_marcacao ) { 

                this.$util.loadItem(this, {
                    service: 'arquivos',
                    func: 'links',
                    parms: {
                        id: this.marcacao.id_marcacao,
                        type: 'marcacao',
                    }
                })
                .then(res => {
                    this.marcacao.arquivos = res;

                    if ( abrir ) {
                        this.$nextTick(() => {
                        this.$refs.upload.abrir();
                        });
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });

            } 

        },

        exibirPacsStatus(marc) {
            if (marc && marc.atendimento && marc.atendimento.atendimento_procedimentos) {
                return marc.atendimento.atendimento_procedimentos.find(
                    (proc) => ( proc.st_pacs == 'OK' ) || proc.st_an || ( proc.procedimento && proc.procedimento.id_modalidade_dicom ) 
                );
            }
            
            return false;
        },

        is_mes_atual(nf) {
            if(nf && nf.dt_competencia) {
                const competencia = moment(nf.dt_competencia, "YYYY-MM-DD");
                const hj = moment();

                return competencia.month() == hj.month();
            }

            return true;
        },

        toggle_exibir_valores () {
            this.espelho_sem_valor = !this.espelho_sem_valor;
            this.$util.setCookie('esv', this.espelho_sem_valor ? 'S' : 'N');
        },

        integrar() {
            if ( !this.marcacao || !this.marcacao.st_id_externo )
                return;

            this.$toast.add({
                severity: "info",
                summary: "Atenção",
                detail: "Integrando...",
                life: 3000
            });

            this.$refs.labetq.abrir();
        },

        enviar_espelho: function () {
            this.$util.atualizar(this, {
                service: 'marcacoes',
                func: 'enviar_espelho',
                dados: {
                    id_atendimento: this.marcacao.id_atendimento,
                }
            });
        },

        reabrir(item) {
            this.$emit("reabrir", item);
        },

        formatCurrency(n) {
            let formatter = new Intl.NumberFormat("pt-Br", {
                style: "currency",
                currency: "BRL",
                currencyDisplay: "code"
            });

            return formatter.format(n).substr(4);
        },
        formatData(data) {
            return moment(data).format("L");
        },
        imprimirRecibo() {

            if ( this.is_pag_consolidado ) { 
                $('.modal').modal('hide');
                this.$util.abrirPagamentos(this.marcacao, this.dados.atendimento.pagamento_atendimento.id_pagamento_atendimento);
                return; 
            }

            if ( this.metodoPagamentos ) { 
                let teste = this.metodoPagamentos.find(item => item.block_recibo);
                
                if ( teste ) { 
                    this.$toast.add({
                        severity: "error",
                        summary: "Atenção",
                        detail: "Recibo não disponível para forma de pagamento: " + teste.st_pagamento,
                        life: 5000
                    });
                    return;
                }
            }

            this.$refs.reportRecibo.configurarPapel("A5");
            this.$nextTick(() =>
                this.$htmlToPaper("recibo", null, () =>
                    console.log("print recibo")
                )
            );
        },
        load(id_marcacao = null) {

            id_marcacao = id_marcacao ? id_marcacao : ( this.marcacao ? this.marcacao.id_marcacao : null );

            let guia_tiss = this.marcacao
                ? ( this.marcacao.plano && this.marcacao.plano.id_operadora != 1 ) ? true : false
                : false;

            if (id_marcacao) {

                this.logo_unidade_operacao = null; 

                this.$store.commit("loading", true);

                this.$util
                    .loadItem(this, {
                        service: "marcacoes",
                        id: id_marcacao,
                        parms: {
                            pagamento: true,
                            guia_tiss: guia_tiss,
                            recibo: true,
                            verificar_contself: true,
                            verificar_zoop: true,
                            verificar_suportpos: true
                        },
                        configs: [
                            'recibo-com-cnpj',
                            'integracao-contself-url',
                            'recibo-consolidar-matmed', 
                        ],
                        with: [
                            "paciente.cadastro.endereco.cidade.estado",
                            "atendimento.atendimento_procedimentos.terceiro.terceiro",
                            "atendimento.pagamentoAtendimento.itemPagamentoAtendimentos.notaFiscalLinks.notaFiscalServico.unidadeOperacao:id_unidade_operacao,st_nome,st_sigla",
                            "atendimento.medico.conselho",
                            "atendimento.medico.estado_conselho",
                            "unidade_operacao:id_unidade_operacao,st_nome,id_endereco,st_cnpj,fl_nota_fiscal,fl_nota_fiscal_eletronica",
                            "unidade_operacao.endereco.cidade.estado",
                            "unidade_operacao.telefoneUnidadeOperacaos.telefone",
                            "unidade_operacao.logo.arquivo", 
                        ]
                    })
                    .then(res => {
                        this.exibir_cnpj = ( this.$store.state.contexto['recibo-com-cnpj'] == 1 );
                        this.consolidar_matmed = ( this.$store.state.contexto['recibo-consolidar-matmed'] == 1 );
                        this.contself = 
                            ( this.$store.state.contexto['integracao-contself-url'] != '' && this.$store.state.contexto['integracao-contself-url'] != null )
                            || (res.contself ? true : false);
                        this.zoop = res.zoop ? true : false;
                        this.suportpos = res.suportpos ? true : false;
                        this.dados = res;

                        if ( res.unidade_operacao ) {
                            if ( res.unidade_operacao.endereco ) {
                                this.unidade.endereco = res.unidade_operacao.endereco;
                            }

                            if ( res.unidade_operacao.st_cnpj ) {
                                this.unidade.st_cnpj = res.unidade_operacao.st_cnpj;
                            }

                            if ( res.uma_via ) {
                                this.uma_via = true;
                            }

                            this.unidade.st_unidade_operacao = res.unidade_operacao.st_nome;
                            this.logo_unidade_operacao = _.get(res, 'unidade_operacao.logo.arquivo.temporary_url', null);
                        }
                    })
                    .finally(() => {
                        this.$store.commit("loading", false);
                    });
            }
        },
        gerarNF: function() {
            if (!confirm("Deseja realmente gerar a Nota Fiscal de Serviço?"))
                return;

            this.$util.atualizar(this, {
                service: "nota_fiscal_servico",
                func: "gerar_nf_pagamento_atendimento",
                redir_api: true,
                toast: true,
                dados: {
                    id_pagamento_atendimento: this.dados.atendimento
                        .pagamento_atendimento.id_pagamento_atendimento
                },
                callback: () => {
                    this.load();
                }
            });
        },
        getStatusClass: function(status) {
            switch (status) {
                case "1":
                    return "text-info";
                case "2":
                    return "text-primary";
                case "3":
                    return "text-warning";
                case "4":
                    return "text-success";
                case "5":
                    return "text-danger";

                default:
                    return "text-info";
            }
        }
    },
    computed: {
        is_pag_consolidado: function () { 

            if ( this.dados 
                && this.dados.atendimento
                && this.dados.atendimento.pagamento_atendimento
                && this.marcacao
                && this.dados.atendimento.pagamento_atendimento.id_pagamento_atendimento
                && !this.dados.atendimento.pagamento_atendimento.id_atendimento
            ) { 
                return true; 
            }

            return false; 

        },

        recebimento_direto: function () { 

            let lista = _.get(this.dados, 'atendimento.pagamento_atendimento.item_pagamento_atendimentos');

            if ( !lista ) { 
                return false;
            }

            if ( lista.find(item => _.get(item, 'estorno.ch_situacao') != 'A' && _.get(item, 'forma_pagamento.fl_repasse_devol')) ) { 
                return true;
            }

            return false;

        },

        titulo_ass: function () { 
            if ( this.recebimento_direto ) { 
                let cpf = _.get(this.dados, 'atendimento.medico.cadastro.st_cpf');
                return _.get(this.dados, 'atendimento.medico.st_nome_exibicao') + ( cpf ? ' / CPF: ' + cpf : '' );
            } else if ( this.dados && _.get(this.dados, 'atendimento.atendimento_procedimentos.0.procedimento.id_especialidade') == 2 ) { 
                return 'Laboratório';
            } else { 
                return 'Clínica';
            }
        },

        texto_rodape: function () {
            if ( this.dados
                && this.dados.cabecalho_laudo
                && this.dados.cabecalho_laudo.st_texto_rodape
                && this.dados.cabecalho_laudo.fl_rodape_recibo ) {
                return this.dados.cabecalho_laudo.st_texto_rodape;
            }

            return null;
        },

        logo_url: function () {
            if ( this.dados
                && this.dados.cabecalho_laudo
                && this.dados.cabecalho_laudo.logo
                && this.dados.cabecalho_laudo.logo.arquivo
                && this.dados.cabecalho_laudo.logo.arquivo.temporary_url ) {
                return this.dados.cabecalho_laudo.logo.arquivo.temporary_url;
            }

            if ( this.logo_unidade_operacao ) { 
                return this.logo_unidade_operacao;
            }

            return null;
        },
        nome_empresa: function () {
            if ( this.dados && this.dados.cabecalho_laudo && this.dados.cabecalho_laudo.st_nome_empresa ) {
                return this.dados.cabecalho_laudo.st_nome_empresa;
            }

            return null;
        },
        valor_total: function() {
            return this.metodoPagamentos.filter(item => item.id_forma_pagamento != 98)
                .reduce((carry, item) => {
                    return Number(carry) + Number(item.dc_valor);
                }, 0);
        },
        valor_pendente: function() {
            return this.metodoPagamentos.filter(item => item.id_forma_pagamento == 98)
                .reduce((carry, item) => {
                    return Number(carry) + Number(item.dc_valor);
                }, 0);
        },
        desconto: function() {
            let total_desconto = 0;
            if (this.dados.atendimento.pagamento_atendimento.desconto != null) {
                total_desconto += Number(
                    this.dados.atendimento.pagamento_atendimento.desconto
                        .dc_valor
                );
            }
            return total_desconto;
        },
        responsavel: function() {
            let responsavel;
            let doc = "";

            if ( this.dados.atendimento.pagamento_atendimento.st_responsavel_financeiro  ) {

                responsavel = this.dados.atendimento.pagamento_atendimento.st_responsavel_financeiro;

                if ( this.dados.atendimento.pagamento_atendimento.st_cpf_cnpj ) { 

                    if ( this.dados.atendimento.pagamento_atendimento.st_cpf_cnpj.length == 11 ) {
                        doc = "CPF: " +
                            this.$util.formatMask(
                                this.dados.atendimento.pagamento_atendimento.st_cpf_cnpj,
                                "cpf"
                            );
                    } else {
                        doc = "CNPJ: " +
                            this.$util.formatMask(
                                this.dados.atendimento.pagamento_atendimento.st_cpf_cnpj,
                                "cnpj"
                            );
                    }

                }

                const paciente = this.dados.paciente.st_nome_social 
                    ? this.dados.paciente.st_nome_social + " (Nome Civil: " + this.dados.paciente.st_nome + ")"
                    : this.dados.paciente.st_nome;

                responsavel += " (" + doc + ", Paciente: " + paciente + ")";

            } else {
                responsavel = ( this.dados.paciente.st_nome_social
                    ? this.dados.paciente.st_nome_social + " (Nome Civil: " + this.dados.paciente.st_nome + ")"
                    : this.dados.paciente.st_nome ) +
                      " (CPF: " +
                      this.$util.formatMask(
                          this.dados.paciente.cadastro.st_cpf,
                          "cpf"
                      ) +
                      ") ";
            }
            return responsavel;
        },
        procedimentos: function() {
            let procedimentos = this.dados.atendimento.atendimento_procedimentos;
            let pacote = [];

            let cobranca_extra = ( this.dados.atendimento.plano.id_operadora && this.dados.atendimento.plano.id_operadora != 1 ) ? true : false;

            _.each(
                _.groupBy(procedimentos, item => item.id_atendimento_pacote ? 'P' + item.id_atendimento_pacote : 'U' + item.id_atendimento_procedimento), 
                items => {
                    let tmp = {};

                    let item = _.first(items);

                    if ( item.id_atendimento_procedimento_empacotado ) { 
                        return; 
                    }

                    if (item.atendimento_pacote) {
                        tmp["nome"] =
                            item.procedimento.st_procedimento +
                            ( ( item.atendimento_pacote && item.atendimento_pacote.procedimento_pacote )
                                ? " " + item.atendimento_pacote.procedimento_pacote.search
                                : ''
                            );
                        //tmp["valor"] = item.procedimento_pacote.pacote.dc_valor;
                        tmp["valor"] = item.atendimento_pacote ? item.atendimento_pacote.dc_valor_pacote : item.procedimento_pacote.pacote.dc_valor;
                        tmp["quantidade"] = 1;
                        tmp["quantidade"] = 1;
                    } else if (!item.procedimento_pacote) {
                        tmp["nome"] = item.procedimento.st_procedimento;
                        tmp["valor"] = item.in_quantidade * item.dc_valor_procedimento;
                        tmp["quantidade"] = item.in_quantidade;
                    }

                    if ( cobranca_extra && !item.id_plano_particular ) { 
                        tmp["valor"] = 0;
                    }

                    // Equipe...
                    tmp["equipes"] = [];
                    if (item.atendimento_procedimento_equipes) {
                        let equipes = [];
                        item.atendimento_procedimento_equipes.forEach(equipe => {
                            if ( equipe.dc_valor > 0 ) { 
                                let equipeItem = {};
                                equipeItem["quantidade"] = 1;
                                equipeItem["valor_unitario"] = equipe.dc_valor;
                                equipeItem["valor"] = equipe.dc_valor;
                                equipeItem["nome_item"] = equipe.grau_participacao ? equipe.grau_participacao.st_grau_participacao : equipe.id_atendimento_procedimento_equipe;
                                equipes.push(equipeItem);
                            }
                        });
                        tmp.equipes = equipes;
                    }

                    // Consumos...
                    tmp["consumos"] = [];
                    if (item.atendimento_procedimento_consumos && item.atendimento_procedimento_consumos.length) {
                        
                        let consumos = [];

                        if ( this.consolidar_matmed ) { 
                            consumos.push({ 
                                nome_item: "Material/Medicamento",
                                quantidade: null, 
                                valor_unitario: null, 
                                valor: _.sumBy(item.atendimento_procedimento_consumos, 'valor_total'), 
                            });
                        } else { 
                            item.atendimento_procedimento_consumos.forEach(consumo => {

                                if ( cobranca_extra && !consumo.id_plano ) { 
                                    return;
                                }

                                if ( consumo.tch ) { 

                                    tmp["valor"] = tmp["valor"] + consumo.valor_total;

                                } else { 

                                    let consumoItem = {};
                                    consumoItem["quantidade"] = consumo.in_quantidade;
                                    consumoItem["valor_unitario"] = consumo.dc_valor_unitario;
                                    consumoItem["valor"] = consumo.valor_total;
                                    consumoItem["nome_item"] = consumo.search;
                                    consumos.push(consumoItem);

                                }

                            });
                        }

                        tmp.consumos = consumos;

                    }
                    pacote.push(tmp);
                }   
            );

            return pacote;
        },
        total: function() {
            // const sum = (acc, item) => acc + Number(item.valor);
            let total_custo = 0;
            this.procedimentos.forEach(item => {
                total_custo += Number(item.valor);
                if (item.equipes != null) {
                    item.equipes.forEach(equipe => {
                        total_custo += equipe.valor;
                    });
                }
                if (item.consumos != null) {
                    item.consumos.forEach(consumo => {
                        total_custo += consumo.valor;
                    });
                }
            });

            return total_custo;
        },
        // consumos:function(){
        //   let comesebebes= this.dados.atendimento.atendimento_procedimentos;
        //   if()
        //   return comesebebes
        // },
        endereco: function() {
            let endereco = "Endereço: ";
            let isEmpty = true;
            if (this.dados.paciente.cadastro.endereco.st_logradouro) {
                endereco += this.dados.paciente.cadastro.endereco.st_logradouro + ",";
                isEmpty = false;
            }
            if (this.dados.paciente.cadastro.endereco.st_numero) {
                endereco +=
                    " " +
                    this.dados.paciente.cadastro.endereco.st_numero +
                    " .";
                isEmpty = false;
            }
            if (this.dados.paciente.cadastro.endereco.st_bairro) {
                endereco +=
                    "  Bairro: " +
                    this.dados.paciente.cadastro.endereco.st_bairro +
                    ".";
                isEmpty = false;
            }
            if (
                this.dados.paciente.cadastro.endereco &&
                this.dados.paciente.cadastro.endereco.cidade
            ) {
                endereco +=
                    " " +
                    this.dados.paciente.cadastro.endereco.cidade.st_cidade;
                if (
                    this.dados.paciente.cadastro.endereco.cidade.estado &&
                    this.dados.paciente.cadastro.endereco.cidade.estado.st_sigla
                ) {
                    endereco +=
                        "/" +
                        this.dados.paciente.cadastro.endereco.cidade.estado
                            .st_sigla;
                }

                isEmpty = false;
            }
            return isEmpty ? "" : endereco;
        },
        metodoPagamentos: function() {
            let pagamentos = [];
            let pagamentosArray = this.dados.atendimento.pagamento_atendimento
                .item_pagamento_atendimentos;

            pagamentosArray
                .filter(
                    item => !item.estorno || item.estorno.ch_situacao != "A"
                )
                .forEach(pagamento => {
                    let st_pagamento = pagamento.forma_pagamento
                        .st_forma_pagamento
                        ? pagamento.forma_pagamento.st_forma_pagamento
                        : "";
                    let forma_pagamento = "";
                    // " R$ " + this.$util.formatMoeda(pagamento.dc_valor);
                    let tmp = {};

                    if (pagamento.forma_pagamento) {
                        if (pagamento.forma_pagamento.bandeira_cartaos) {
                            let cartao = _.find(
                                pagamento.forma_pagamento.bandeira_cartaos,
                                item => {
                                    return (
                                        item.id_bandeira_cartao ==
                                        pagamento.id_bandeira_cartao
                                    );
                                }
                            );

                            forma_pagamento += cartao.st_bandeira_cartao;

                            if (pagamento.st_autorizacao) {
                                forma_pagamento +=
                                    " - Nº Autorização: " +
                                    pagamento.st_autorizacao;
                            }
                            if (pagamento.in_parcelas) {
                                forma_pagamento +=
                                    " - Nº Parcelas: " + pagamento.in_parcelas;
                            }
                        } else if (pagamento.cheque && pagamento.cheque.banco) {
                            forma_pagamento =
                                forma_pagamento + pagamento.cheque.banco.search;
                            forma_pagamento =
                                forma_pagamento +
                                " - Cheque #" +
                                pagamento.cheque.in_numero;
                            forma_pagamento =
                                forma_pagamento +
                                " - Venc.: " +
                                this.$util.getFormatDate(
                                    pagamento.cheque.dt_vencimento
                                );
                        }
                    }
                    tmp["st_pagamento"] = st_pagamento;
                    tmp["forma_pagamento"] = forma_pagamento;
                    tmp["dc_valor"] = pagamento.dc_valor;
                    tmp["id_forma_pagamento"] = pagamento.id_forma_pagamento;
                    tmp["block_recibo"] = _.get(pagamento, 'forma_pagamento.fl_block_recibo');
                    tmp["transaction_id"] = _.get(pagamento, 'js_outros.zoop.transaction_id');

                    pagamentos.push(tmp);
                });

            return pagamentos;
        },
        possuiNF: function() {
            const nfLinks = _.get(
                this.dados,
                "atendimento.pagamento_atendimento.nota_fiscal_links"
            );
            return (
                nfLinks != undefined &&
                Array.isArray(nfLinks) &&
                nfLinks.length > 0
            );
        },

        listaNf: function() {
            // if (!this.possuiNF) return [];

            let links =  this.dados.atendimento.pagamento_atendimento
                .nota_fiscal_links;

            const itemsAdiant = _.get(this.dados, 'atendimento.pagamento_atendimento_link.pagamento_atendimento.item_pagamento_atendimentos', []);
            if (itemsAdiant.length > 0) {
                let adiantamento = itemsAdiant.filter(item => item.adiantamento);
                if (adiantamento.length > 0) {
                    adiantamento.forEach(itemAdiantamento => {
                        if (itemAdiantamento.adiantamento.nota_fiscal_link) {
                            let adiantamentoLink = itemAdiantamento.adiantamento.nota_fiscal_link;
                            adiantamentoLink.adiantamento = true;
                            links.push(adiantamentoLink);
                        }
                    });
                }
            }

            if(!links) {
                return [];
            }

            return links;
        }
    },
    mounted() {
        this.espelho_sem_valor = this.$util.getCookie('esv') == 'N' ? true : false;

        this.unidade = this.$store.state.unidade;
        this.load();
    }
};
</script>

<style></style>